import MuiAppBar from '@mui/material/AppBar';
import type { AppBarProps } from './IAppBar';
import { styles } from './styles';

const AppBar = ({ sx, ...rest }: AppBarProps) => (
    <MuiAppBar
        sx={[styles.root, ...(Array.isArray(sx) ? sx : [sx])]}
        {...rest}
    />
);

export default AppBar;
